module.exports = __webpack_public_path__ + "img/P150T_weapon_64.b764351c.png";